export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/FidelityV2/theme/components/scorecard/MetricsLabels/index.js